<template>
  <div
    :class="['quick-box', quickGrouponVisibility ? 'show' : 'hide']"
    v-if="quickGrouponInfo"
    tabindex="0"
    :aria-label="`Ta的团只差${quickGrouponInfo.needNumber}人，剩余${formatTimeLabel()}`"
    v-track="{
      act: 'show',
      params: {
        cfrom: '187|001|02|077',
        event_id: '187|001|02|077',
        page_name: 1,
        group_buy_content: 3,
        sku_id: skuInfo.commoditySkuBaseInfo.skuId,
        grouponid: quickGrouponInfo.grouponId
      }
    }"
  >
    <img :src="quickGrouponInfo.userAvatar" class="q-avatar" alt="" />
    <div class="q-content" aria-hidden="true">
      Ta的团只差{{ quickGrouponInfo.needNumber }}人，剩余&nbsp;
      <v-count-down
        ref="count"
        class="q-count"
        :showMSecond="true"
        v-if="quickGrouponInfo.expireTime > quickGrouponInfo.currentTime"
        :current="quickGrouponInfo.currentTime * 1"
        :start="quickGrouponInfo.startTime * 1"
        :end="quickGrouponInfo.expireTime * 1"
      ></v-count-down>
    </div>
    <v-button
      size="small"
      class="q-btn"
      @click="joinGroup(quickGrouponInfo.grouponId)"
      v-track="{
        act: 'click',
        params: {
          cfrom: '187|001|01|077',
          event_id: '187|001|01|077',
          page_name: 1,
          group_buy_content: 3,
          sku_id: skuInfo.commoditySkuBaseInfo.skuId,
          grouponid: quickGrouponInfo.grouponId
        }
      }"
    >
      快速参团
    </v-button>
  </div>
</template>

<script>
// 埋点数据
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'QuickGroupon',
  computed: {
    ...mapState('detailv3', ['quickGrouponInfo', 'quickGrouponVisibility', 'skuInfo']),
    ...mapGetters('detailv3', ['goodsType', 'isSimpleGroup'])
  },
  // watch: {
  //   quickGrouponInfo: {
  //     handler(val) {
  //       // 重置定时器
  //       this.$nextTick(() => {
  //         if (val.expireTime > val.currentTime) {
  //           this.$refs.count.init()
  //         }
  //       })
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    ...mapActions('detailv3', ['showSkuSelect']),
    formatTimeLabel() {
      let time = this.quickGrouponInfo.expireTime * 1 - this.quickGrouponInfo.currentTime * 1
      let h = parseInt(time / 3600000) % 24
      let m = parseInt(time / 60000) % 60
      return `${h}小时${m}分`
    },
    // 参团
    joinGroup(grouponId) {
      // 如果拼团，且只有一个sku，直接进行开团提交，不用打开弹层
      if (this.isSimpleGroup) {
        this.$emit('submit', {
          grouponId
        })
      } else {
        this.showSkuSelect({
          isShow: true,
          params: {
            source: 16,
            grouponId: grouponId
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
